export function getRequestProfileTabRatingApiParams(requestId) {
  return {
    request_id: requestId,
  }
}

export function getRequestProfileRatingItemsData({ data }) {
  return data.items
}

export function checkRequestProfileRatingIsLastPage() {
  return true
}
